import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestUnblockAffinityPairing } from "./unblockAffinityPairing.request";

const useUnblockAffinityPairing = (
  options?: MutationOptions<{ ok: true }, ApiServiceError<ApiError>, string>
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: requestUnblockAffinityPairing,
    ...options,
    onSuccess: (data, variables, ctx) => {
      void queryClient.invalidateQueries({
        queryKey: ["recommendation", "affinity", "blacklist"]
      });
      options?.onSuccess?.(data, variables, ctx);
    }
  });
};

export default useUnblockAffinityPairing;
